<template>
  <div>
    <v-container fluid>
      <v-row dense>
        <v-col align="center">Quality Level<pie-chart :chart-data="qualityLevelChartData" :options="defaultChartOptions"/></v-col>
        <v-col align="center">Detailed Water<pie-chart :chart-data="detailedWaterChartData" :options="defaultChartOptions"/></v-col>
        <v-col align="center">Hide Anchor Chain Under Water<pie-chart :chart-data="hideAnchorChainChartData" :options="defaultChartOptions"/></v-col>
        <v-col align="center">Fullscreen<pie-chart :chart-data="fullScreenChartData" :options="defaultChartOptions"/></v-col>
        <v-col align="center">
          <bar-chart :chart-data="physicsPriorityChartData" :options="defaultChartOptions"/>
          (and {{ this.physicsPriorityOccurringOnce.true }} others with 1 occurrence)
        </v-col>
      </v-row>
    </v-container>
    <bar-chart :chart-data="widthHeightChartData" :options="defaultChartOptions"/>
    <bar-chart :chart-data="fpsDeltaChartData" :options="defaultChartOptions"/>
  </div>
</template>

<script>
import {eSailServerPublic} from "@/plugins/axios";
import _ from "lodash";
import BarChart from "@/components/charts/BarChart";
import PieChart from "@/components/charts/PieChart";
import 'chartjs-plugin-colorschemes';

export default {
  name: "UserSettingsStatistics",
  components: {PieChart, BarChart},
  data: () => ({
    statistics: {},
    fullScreenChartData: {},
    detailedWaterChartData: {},
    hideAnchorChainChartData: {},
    widthHeightChartData: {},
    qualityLevelChartData: {},
    physicsPriorityChartData: {},
    fpsDeltaChartData: {},
    physicsPriorityOccurringOnce: 0,
    defaultChartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        colorschemes: {
          scheme: 'tableau.Tableau10'
        }
      }
    }
  }),
  mounted() {
    eSailServerPublic.get('admin/statistics/user-settings', { headers: { Authorization: `Bearer ` + this.$auth.token() }})
        .then(response => {
          this.statistics = response.data
          this.fullScreenChartData = {
            labels: _.map(this.statistics.fullscreen, 'name'),
            datasets: [{
              data: _.map(this.statistics.fullscreen, 'count')
            }]
          }
          this.detailedWaterChartData = {
            labels: _.map(this.statistics.detailedWater, 'name'),
            datasets: [{
              data: _.map(this.statistics.detailedWater, 'count')
            }]
          }
          this.hideAnchorChainChartData = {
            labels: _.map(this.statistics.hideAnchorChain, 'name'),
            datasets: [{
              data: _.map(this.statistics.hideAnchorChain, 'count')
            }]
          }
          this.qualityLevelChartData = {
            labels: _.map(this.statistics.qualityLevel, 'name'),
            datasets: [{
              data: _.map(this.statistics.qualityLevel, 'count')
            }]
          }
          this.widthHeightChartData = {
            labels: _.map(this.statistics.widthHeightRate, 'name'),
            datasets: [{
              label: 'Screen Resolution (Width x Height @ Framerate)',
              data: _.map(this.statistics.widthHeightRate, 'count')
            }]
          }
          this.physicsPriorityOccurringOnce = _.countBy(this.statistics.physicsPriority, item => { return item.count === 1 })
          this.statistics.physicsPriority = _.filter(this.statistics.physicsPriority, item => { return item.count > 1 })
          this.physicsPriorityChartData = {
            labels: _.map(this.statistics.physicsPriority, 'name'),
            datasets: [{
              label: 'Physics Priority',
              data: _.map(this.statistics.physicsPriority, 'count')
            }]
          }
          this.fpsDeltaChartData = {
            labels: _.map(this.statistics.fpsDelta, 'name'),
            datasets: [{
              label: 'FPS delta distribution (desired vs achieved framerates)',
              data: _.map(this.statistics.fpsDelta, 'count')
            }]
          }
        })
  },
  methods: {
    getColorForName(name) {
      switch (name) {
        case "RACE":
        case "RACE (Course)":
        case "PUBLIC":
          return '#2189f1'
        case "TIME_TRIAL":
        case "PRIVATE":
          return '#21eaf1'
        default:
          return '#b0afaf'
      }
    }
  }
}
</script>

<style scoped>

</style>